import React from 'react'
import { Button, Input } from '@byscott-io/corebyscott'
import { withUserStore } from '../../../contexts/UserStore'
import Lex from '../../Shared/Lex'

const AccountLexicon = ({ userStore }) => {
  const form = {}

  const lex = userStore.lex

  const save = () => {
    userStore.updateLexicon(
      Object.keys(lex).filter(t => form[t].value !== lex[t]).map(t => {
        return { name: t, value: form[t].value }
      }))
  }

  return (
    <div className="cbs-scope mx-auto max-w-2xl p-4">
      {Object.keys(lex).map((t, i) =>
        <div className="mb-2 flex items-center gap-3" key={i}>
          <div className="flex-1 text-right">{t}</div>
          <div className="flex-1">
            <Input
              name={t} innerRef={el => form[t] = el}
              defaultValue={lex[t]}
            />
          </div>
        </div>)}
      <div className="mt-4 text-right">
        <Button color="success" onClick={() => save()}><Lex term="save" /></Button>
      </div>
    </div>
  )
}

export default withUserStore(AccountLexicon)
